import { formatDateTime } from '@belong/common';
import { Image, Text } from '@belong/ui';
import clsx from 'clsx';
import type { ReviewModel } from 'src/api/models';
import { getReviewerFormattedName } from 'src/components/testimonial-reviews/utils';
import { getRegionFromEnum } from 'src/utils/region';

type Props = {
  review: ReviewModel;
};

export function TestimonialReviewItem({ review }: Props) {
  const {
    reviewerImage,
    reviewerRole,
    reviewDate,
    reviewText,
    reviewerName,
    regionName,
    city,
  } = review;

  // `!`: `reviewerName` is optional on the model, and this helper already
  // dereferences the split result on the next line.
  const reviewerFormattedName = getReviewerFormattedName(reviewerName!);

  return (
    <div className="gap-sm px-2sm lg:px-lg flex w-full flex-col">
      <div className="h-3xl w-3xl">
        <Image
          alt=""
          className={clsx(
            'rounded object-cover',
            reviewerImage && 'border-light-dark-navy border border-solid',
          )}
          src={reviewerImage ?? 'icons/review-ghost.svg'}
        />
      </div>
      <div>
        <div className="gap-sm flex">
          {reviewerFormattedName && (
            <Text fontWeight="semibold">{reviewerFormattedName}</Text>
          )}
          <div className="gap-xs flex items-center">
            <Image alt="" className="w-2sm" src="icons/verified.svg" />
            <Text fontWeight="semibold" variant="p1">
              Verified Review
            </Text>
          </div>
        </div>
        <Text>
          {city
            ? `${city} ${reviewerRole}`
            : `${getRegionFromEnum(regionName)} ${reviewerRole}`}
        </Text>
        <Text>
          {formatDateTime({
            dateTime: reviewDate,
            format: 'MMM y',
          })}
        </Text>
      </div>
      <Text>{reviewText}</Text>
    </div>
  );
}
